module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-minus-fill-5d8813e1.svg";